(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire931a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire931a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4rQy7", function(module, exports) {

$parcel$export(module.exports, "isValidAccountNumber", () => $33d2723ce1692680$export$76ea90c17c1016df);
$parcel$export(module.exports, "isValidPin", () => $33d2723ce1692680$export$6e3f5be18b3338ce);
function $33d2723ce1692680$export$76ea90c17c1016df(accountNumberElement) {
    let isValid = false;
    if (accountNumberElement.value == "") isValid = false;
    else isValid = accountNumberElement.checkValidity();
    return isValid;
}
function $33d2723ce1692680$export$6e3f5be18b3338ce(pinElement) {
    return !pinElement.validity.valueMissing && !pinElement.validity.patternMismatch;
}

});

parcelRegister("8JeXm", function(module, exports) {

$parcel$export(module.exports, "AuthenticationMethod", () => $65ae20bed3355038$export$44011cfd31c4acd);
$parcel$export(module.exports, "OtpVerificationMode", () => $65ae20bed3355038$export$6595456e39b2b16d);
$parcel$export(module.exports, "getBalanceAsync", () => $65ae20bed3355038$export$4af2bca4e077d115);
$parcel$export(module.exports, "refreshAntiForgeryTokenAsync", () => $65ae20bed3355038$export$3b7ffcb18dc836b8);
$parcel$export(module.exports, "getAccountVerificationTypeAsync", () => $65ae20bed3355038$export$e302f7defdac8285);
$parcel$export(module.exports, "sendVerificationCodeAsync", () => $65ae20bed3355038$export$ffec8a428f8b1884);
$parcel$export(module.exports, "postValidateOtpPinAsync", () => $65ae20bed3355038$export$584fc58c25f79dc3);

var $awDB0 = parcelRequire("awDB0");

var $hJMXW = parcelRequire("hJMXW");
var $65ae20bed3355038$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $65ae20bed3355038$export$44011cfd31c4acd;
(function(AuthenticationMethod) {
    AuthenticationMethod["Email"] = "email";
    AuthenticationMethod["Phone"] = "phone";
    AuthenticationMethod["Pin"] = "pin";
})($65ae20bed3355038$export$44011cfd31c4acd || ($65ae20bed3355038$export$44011cfd31c4acd = {}));
var $65ae20bed3355038$export$6595456e39b2b16d;
(function(OtpVerificationMode) {
    OtpVerificationMode["Email"] = "email";
    OtpVerificationMode["Sms"] = "sms";
})($65ae20bed3355038$export$6595456e39b2b16d || ($65ae20bed3355038$export$6595456e39b2b16d = {}));
function $65ae20bed3355038$export$4af2bca4e077d115(accountNumber) {
    return $65ae20bed3355038$var$__awaiter(this, void 0, void 0, function*() {
        const errorMessageDiv = document.getElementById("errMessage");
        const spinnerDiv = document.getElementById("spinner");
        const payload = {
            accountnumber: accountNumber
        };
        const apiUrl = "/api/Balance";
        const contentTypeKey = "Content-Type";
        const RequestVerificationTokenKey = "RequestVerificationToken";
        const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]');
        let token = tokenElement.value;
        let headers = new Headers();
        headers.append(contentTypeKey, "application/json");
        headers.append(RequestVerificationTokenKey, token);
        try {
            yield $65ae20bed3355038$export$3b7ffcb18dc836b8();
            const response = yield fetch(apiUrl, {
                method: "post",
                headers: headers,
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const responsedata = yield response.json();
                const redirectUrlKey = "redirectUrl";
                (0, $awDB0.hideSpinner)(spinnerDiv);
                if (redirectUrlKey in responsedata) window.location.href = responsedata[redirectUrlKey];
                else (0, $awDB0.showErrorDiv)(errorMessageDiv, (0, $hJMXW.unknownErrorMessage));
            } else {
                (0, $awDB0.hideSpinner)(spinnerDiv);
                const responsedata = yield response.json();
                const controllerApiErrorKey = "controllerApiError";
                var errorMessage;
                if (controllerApiErrorKey in responsedata) errorMessage = responsedata[controllerApiErrorKey];
                else errorMessage = (0, $hJMXW.unknownErrorMessage);
                (0, $awDB0.showErrorDiv)(errorMessageDiv, errorMessage);
            }
        } catch (error) {
            (0, $awDB0.hideSpinner)(spinnerDiv);
            (0, $awDB0.showErrorDiv)(errorMessageDiv, (0, $hJMXW.unknownErrorMessage));
        }
    });
}
function $65ae20bed3355038$export$e302f7defdac8285(billingAccount) {
    return $65ae20bed3355038$var$__awaiter(this, void 0, void 0, function*() {
        let accountVerificationType;
        try {
            const payload = {
                billingAccount: billingAccount
            };
            const apiUrl = "/api/mfa/AuthMethod";
            const contentTypeKey = "Content-Type";
            const RequestVerificationTokenKey = "RequestVerificationToken";
            const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]');
            let token = tokenElement.value;
            let headers = new Headers();
            headers.append(contentTypeKey, "application/json");
            headers.append(RequestVerificationTokenKey, token);
            const response = yield fetch(apiUrl, {
                method: "post",
                headers: headers,
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const responsedata = yield response.json();
                accountVerificationType = responsedata.authMethods;
            } else {
                const responsedata = yield response.json();
                const controllerApiErrorKey = "controllerApiError";
                if (controllerApiErrorKey in responsedata) {
                    const errorMessage = responsedata[controllerApiErrorKey];
                    (0, $awDB0.onErrorAction)(errorMessage);
                } else {
                    const spinnerDiv = document.getElementById("spinner");
                    (0, $awDB0.hideSpinner)(spinnerDiv);
                    const errorMessageUnableToVerify = document.getElementById("errorMessageUnableToVerify");
                    errorMessageUnableToVerify.classList.remove("hide");
                    (0, $awDB0.toggleUpdateNextToTryAgainandNextButton)();
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
        return accountVerificationType;
    });
}
function $65ae20bed3355038$export$ffec8a428f8b1884(billingAccount, authMethod) {
    return $65ae20bed3355038$var$__awaiter(this, void 0, void 0, function*() {
        let isOtpSent = false;
        const spinnerDiv = document.getElementById("spinner");
        (0, $awDB0.showSpinner)(spinnerDiv);
        try {
            const payload = {
                BillingAccountNumber: billingAccount,
                OtpVerificationMode: authMethod
            };
            const apiUrl = "/api/mfa/OtpChallenge";
            const contentTypeKey = "Content-Type";
            const RequestVerificationTokenKey = "RequestVerificationToken";
            const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]');
            let token = tokenElement.value;
            let headers = new Headers();
            headers.append(contentTypeKey, "application/json");
            headers.append(RequestVerificationTokenKey, token);
            const response = yield fetch(apiUrl, {
                method: "post",
                headers: headers,
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const responsedata = yield response.json();
                let status = responsedata.status;
                if (status == 200) isOtpSent = true;
                else (0, $awDB0.onErrorAction)((0, $hJMXW.unknownErrorMessage));
                (0, $awDB0.hideSpinner)(spinnerDiv);
            } else {
                const responsedata = yield response.json();
                const controllerApiErrorKey = "controllerApiError";
                var errorMessage;
                if (controllerApiErrorKey in responsedata) errorMessage = responsedata[controllerApiErrorKey];
                else errorMessage = (0, $hJMXW.unknownErrorMessage);
                (0, $awDB0.onErrorAction)(errorMessage);
            }
        } catch (error) {
            (0, $awDB0.onErrorAction)((0, $hJMXW.unknownErrorMessage));
        }
        (0, $awDB0.hideSpinner)(spinnerDiv);
        return isOtpSent;
    });
}
function $65ae20bed3355038$export$584fc58c25f79dc3(billingAccount, authenticationMethod, otpOrPin) {
    return $65ae20bed3355038$var$__awaiter(this, void 0, void 0, function*() {
        const spinnerDiv = document.getElementById("spinner");
        const payload = {
            AuthMethod: authenticationMethod,
            BillingAccount: billingAccount,
            OtpCodePIN: otpOrPin
        };
        const apiUrl = "/api/Mfa/ValidateOtpPin";
        const contentTypeKey = "Content-Type";
        const RequestVerificationTokenKey = "RequestVerificationToken";
        const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]');
        let token = tokenElement.value;
        let headers = new Headers();
        headers.append(contentTypeKey, "application/json");
        headers.append(RequestVerificationTokenKey, token);
        (0, $awDB0.showSpinner)(spinnerDiv);
        try {
            yield $65ae20bed3355038$export$3b7ffcb18dc836b8();
            const response = yield fetch(apiUrl, {
                method: "post",
                headers: headers,
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const responsedata = yield response.json();
                let status = responsedata.status;
                if (status == 200) $65ae20bed3355038$export$4af2bca4e077d115(billingAccount);
                else {
                    let authType = authenticationMethod == $65ae20bed3355038$export$44011cfd31c4acd.Pin ? "Pin" : "code";
                    (0, $awDB0.onErrorAction)("Invalid " + authType + ", please try again.");
                }
                (0, $awDB0.hideSpinner)(spinnerDiv);
            } else {
                const responsedata = yield response.json();
                const controllerApiErrorKey = "controllerApiError";
                var errorMessage;
                if (controllerApiErrorKey in responsedata) errorMessage = responsedata[controllerApiErrorKey];
                else errorMessage = (0, $hJMXW.unknownErrorMessage);
                (0, $awDB0.onErrorAction)(errorMessage);
            }
        } catch (error) {
            (0, $awDB0.onErrorAction)((0, $hJMXW.unknownErrorMessage));
        }
    });
}
function $65ae20bed3355038$export$3b7ffcb18dc836b8() {
    return $65ae20bed3355038$var$__awaiter(this, void 0, void 0, function*() {
        try {
            const apiUrl = "/api/Balance/GetNewToken";
            const response = yield fetch(apiUrl, {
                method: "GET",
                credentials: "include"
            });
            const token = yield response.text();
            const antiForegeryTokenElement = document.querySelector('[name = "__RequestVerificationToken"]');
            if (antiForegeryTokenElement) antiForegeryTokenElement.value = token;
        } catch (error) {
            console.error("Error:", error);
        }
    });
}

});
parcelRegister("awDB0", function(module, exports) {

$parcel$export(module.exports, "toggleMessageValidation", () => $7a9b9b6f36c0e64b$export$cb5267591e237aa2);
$parcel$export(module.exports, "deleteInvalidCharactersFromAccountNumber", () => $7a9b9b6f36c0e64b$export$c6cd180d7aaeabb1);
$parcel$export(module.exports, "getOtpNumberIfValidOrNegative", () => $7a9b9b6f36c0e64b$export$fbaa8d084f323ef5);
$parcel$export(module.exports, "hideErrorDiv", () => $7a9b9b6f36c0e64b$export$975f08228d4cf7e6);
$parcel$export(module.exports, "hideSpinner", () => $7a9b9b6f36c0e64b$export$95fec50f68454318);
$parcel$export(module.exports, "onErrorAction", () => $7a9b9b6f36c0e64b$export$536c998f26de91f4);
$parcel$export(module.exports, "showErrorDiv", () => $7a9b9b6f36c0e64b$export$ee84ddf60d287b00);
$parcel$export(module.exports, "showSpinner", () => $7a9b9b6f36c0e64b$export$2a7a135fa1ec651f);
$parcel$export(module.exports, "toggleAccountNumberValidationMessage", () => $7a9b9b6f36c0e64b$export$ea3c98ca50021456);
$parcel$export(module.exports, "toggleEmailPhoneValidationMessage", () => $7a9b9b6f36c0e64b$export$56b64ab42b2a1afe);
$parcel$export(module.exports, "toggleOtpValidationMessage", () => $7a9b9b6f36c0e64b$export$9342769383f0907d);
$parcel$export(module.exports, "togglePinAuthMethodValidationMessage", () => $7a9b9b6f36c0e64b$export$59a8e66d17cdd98b);
$parcel$export(module.exports, "togglePinValidationMessage", () => $7a9b9b6f36c0e64b$export$2e1877e251fe8d2f);
$parcel$export(module.exports, "toggleUpdateNextToTryAgainandNextButton", () => $7a9b9b6f36c0e64b$export$343194a3c22712d2);

var $hJMXW = parcelRequire("hJMXW");
const $7a9b9b6f36c0e64b$var$accountMessageDivId = "accountMessage";
function $7a9b9b6f36c0e64b$var$customerAccountValidationFailureMessage(message, isSuccess) {
    const errorMessageDivId = "accountMessage";
    $7a9b9b6f36c0e64b$export$cb5267591e237aa2(errorMessageDivId, isSuccess, message);
}
function $7a9b9b6f36c0e64b$export$c6cd180d7aaeabb1(accountNumber) {
    const accountNumberFormatRegex = /^[0-9]{10}/;
    if (accountNumberFormatRegex.test(accountNumber) && accountNumber.substring(10, 11).match("/")) {
        accountNumber = accountNumber.substring(0, 11) + accountNumber.substring(11, 16).replace((0, $hJMXW.nonNumericRegex), "");
        accountNumber = accountNumber.substring(0, 12);
    } else accountNumber = (accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.substring(0, 16).replace((0, $hJMXW.nonAlphanumericRegex), "")) || "";
    return accountNumber;
}
function $7a9b9b6f36c0e64b$export$fbaa8d084f323ef5(otpSingleChar) {
    let otpValidNumber = -1;
    const otpChar0 = document.getElementById(otpSingleChar);
    if (!otpChar0 || otpChar0.value.length !== 1) otpValidNumber = -1;
    let pin = otpChar0.value.replace((0, $hJMXW.nonAlphanumericRegex), "");
    if (/\d/.test(pin)) otpValidNumber = Number(pin);
    return otpValidNumber;
}
function $7a9b9b6f36c0e64b$export$975f08228d4cf7e6(div) {
    div.innerText = "";
    div.classList.add("hide");
    div.setAttribute("aria-live", "off");
}
function $7a9b9b6f36c0e64b$export$95fec50f68454318(spinnerDiv) {
    spinnerDiv.classList.add("hide");
}
function $7a9b9b6f36c0e64b$export$536c998f26de91f4(message) {
    const spinnerDiv = document.getElementById("spinner");
    $7a9b9b6f36c0e64b$export$95fec50f68454318(spinnerDiv);
    $7a9b9b6f36c0e64b$var$customerAccountValidationFailureMessage(message, false);
}
function $7a9b9b6f36c0e64b$export$ee84ddf60d287b00(div, message) {
    div.classList.remove("hide");
    div.innerText = message;
    div.setAttribute("aria-live", "assertive");
}
function $7a9b9b6f36c0e64b$export$2a7a135fa1ec651f(spinnerDiv) {
    spinnerDiv.classList.remove("hide");
}
function $7a9b9b6f36c0e64b$export$ea3c98ca50021456(accountNumberTextBox, isAccountNumberValid) {
    const accountErrorMessageDiv = document.getElementById($7a9b9b6f36c0e64b$var$accountMessageDivId);
    if (isAccountNumberValid) {
        $7a9b9b6f36c0e64b$export$975f08228d4cf7e6(accountErrorMessageDiv);
        $7a9b9b6f36c0e64b$export$cb5267591e237aa2($7a9b9b6f36c0e64b$var$accountMessageDivId, isAccountNumberValid, " Please click next to continue.");
    } else {
        const accountNumberLengthMessage = "Account number must be at least 7 characters long.";
        const accountNumberRequiredMessage = "Billing account number is required.";
        let message;
        if (accountNumberTextBox.validity.valueMissing) message = accountNumberRequiredMessage;
        else if (accountNumberTextBox.validity.patternMismatch) message = accountNumberLengthMessage;
        else message = "";
        $7a9b9b6f36c0e64b$export$cb5267591e237aa2($7a9b9b6f36c0e64b$var$accountMessageDivId, isAccountNumberValid, message);
    }
    accountNumberTextBox.setAttribute("aria-invalid", isAccountNumberValid ? "false" : "true");
}
function $7a9b9b6f36c0e64b$export$cb5267591e237aa2(divElementId, isSuccess, message) {
    const messageDiv = document.getElementById(divElementId);
    if (!messageDiv) return;
    if (message.trim().length === 0) {
        messageDiv.classList.add("hide");
        return;
    }
    messageDiv.innerText = message;
    messageDiv.classList.remove("hide", "center", "onSuccessMessage", "onSuccess", "onErrorMessage");
    if (isSuccess) {
        messageDiv.classList.add("onSuccessMessage");
        if (message.toLowerCase().indexOf("please click next to continue")) messageDiv.classList.add("onSuccess");
    } else messageDiv.classList.add("onErrorMessage", "center");
}
function $7a9b9b6f36c0e64b$export$56b64ab42b2a1afe() {
    let errorMessageDiv = document.getElementById("errMessage");
    const email = document.getElementById("email");
    const mobile = document.getElementById("mobile");
    let emailMobileRequiredMessage = "";
    let isValid = false;
    if (email != null && mobile != null && (email.checked || mobile.checked)) {
        $7a9b9b6f36c0e64b$export$975f08228d4cf7e6(errorMessageDiv);
        isValid = true;
    } else emailMobileRequiredMessage = "Please select Email or Mobile phone to verify your account.";
    $7a9b9b6f36c0e64b$export$ee84ddf60d287b00(errorMessageDiv, emailMobileRequiredMessage);
    return isValid;
}
function $7a9b9b6f36c0e64b$export$9342769383f0907d() {
    let isValid = false;
    const pinErrorMessageDiv = document.getElementById("errMessage");
    const otpChar0 = document.getElementById("otpChar0").value;
    const otpChar1 = document.getElementById("otpChar1").value;
    const otpChar2 = document.getElementById("otpChar2").value;
    const otpChar3 = document.getElementById("otpChar3").value;
    const otpChar4 = document.getElementById("otpChar4").value;
    const otpChar5 = document.getElementById("otpChar5").value;
    if (otpChar0 != "" && otpChar1 != "" && otpChar2 != "" && otpChar3 != "" && otpChar4 != "" && otpChar5 != "") {
        isValid = true;
        $7a9b9b6f36c0e64b$export$975f08228d4cf7e6(pinErrorMessageDiv);
    } else {
        const pinRequiredMessage = "6-digit code is required.";
        $7a9b9b6f36c0e64b$export$ee84ddf60d287b00(pinErrorMessageDiv, pinRequiredMessage);
    }
    return isValid;
}
function $7a9b9b6f36c0e64b$export$59a8e66d17cdd98b() {
    let isValid = false;
    const pinErrorMessageDiv = document.getElementById("errMessage");
    const pinChar0 = document.getElementById("pinChar0").value;
    const pinChar1 = document.getElementById("pinChar1").value;
    const pinChar2 = document.getElementById("pinChar2").value;
    const pinChar3 = document.getElementById("pinChar3").value;
    if (pinChar0 != "" && pinChar1 != "" && pinChar2 != "" && pinChar3 != "") {
        isValid = true;
        $7a9b9b6f36c0e64b$export$975f08228d4cf7e6(pinErrorMessageDiv);
    } else {
        const pinRequiredMessage = "4-digit PIN is required.";
        $7a9b9b6f36c0e64b$export$ee84ddf60d287b00(pinErrorMessageDiv, pinRequiredMessage);
    }
    return isValid;
}
function $7a9b9b6f36c0e64b$export$2e1877e251fe8d2f(pinTextBox, isPinValid) {
    const pinErrorMessageDiv = document.getElementById("pinErrorMessage");
    if (isPinValid) $7a9b9b6f36c0e64b$export$975f08228d4cf7e6(pinErrorMessageDiv);
    else {
        const pinRequiredMessage = "4-digit PIN is required.";
        $7a9b9b6f36c0e64b$export$ee84ddf60d287b00(pinErrorMessageDiv, pinRequiredMessage);
    }
    pinTextBox.setAttribute("aria-invalid", isPinValid ? "false" : "true");
}
function $7a9b9b6f36c0e64b$export$343194a3c22712d2() {
    var _a, _b;
    const otpSignIn = document.getElementById("otp-signIn");
    if (otpSignIn) {
        if (((_a = otpSignIn.textContent) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) === "next") {
            otpSignIn.textContent = "Try Again";
            otpSignIn.title = "Try Again";
            const accountNumberTextBox = document.getElementById("accountNumberTextBox");
            if (accountNumberTextBox) accountNumberTextBox.disabled = true;
        } else if (((_b = otpSignIn.textContent) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "try again") {
            otpSignIn.textContent = "Next";
            const accountNumberTextBox = document.getElementById("accountNumberTextBox");
            if (accountNumberTextBox) accountNumberTextBox.disabled = true;
        }
    }
}

});
parcelRegister("hJMXW", function(module, exports) {

$parcel$export(module.exports, "nonAlphanumericRegex", () => $ce9c9f376cb2511d$export$85ceed2b2a591268);
$parcel$export(module.exports, "nonNumericRegex", () => $ce9c9f376cb2511d$export$9839fa8d0b5c8aae);
$parcel$export(module.exports, "emailOTPHeadingLabel", () => $ce9c9f376cb2511d$export$a20a4f121337c9c2);
$parcel$export(module.exports, "mobileOTPHeadingLabel", () => $ce9c9f376cb2511d$export$4dbd01bc988d6884);
$parcel$export(module.exports, "unknownErrorMessage", () => $ce9c9f376cb2511d$export$b2aaee0335361ad7);
const $ce9c9f376cb2511d$export$85ceed2b2a591268 = /[^0-9a-zA-Z]/g;
const $ce9c9f376cb2511d$export$9839fa8d0b5c8aae = /[^0-9]/g;
const $ce9c9f376cb2511d$export$a20a4f121337c9c2 = "We just sent you a 6-digit code to your email address. Enter it here to verify your account.";
const $ce9c9f376cb2511d$export$4dbd01bc988d6884 = "We just sent you a 6-digit code to your mobile number. Enter it here to verify your account.";
const $ce9c9f376cb2511d$export$b2aaee0335361ad7 = "There was an unexpected error that may be temporary. Please try again later.";

});




var $4rQy7 = parcelRequire("4rQy7");

var $8JeXm = parcelRequire("8JeXm");

var $hJMXW = parcelRequire("hJMXW");

var $awDB0 = parcelRequire("awDB0");
const $ea41d65ac2a28d87$var$accountErrorMessageDiv = document.getElementById("accountErrorMessage");
const $ea41d65ac2a28d87$var$accountNumberTextBox = document.getElementById("billingAccountNumber");
const $ea41d65ac2a28d87$var$errorMessageDiv = document.getElementById("errMessage");
const $ea41d65ac2a28d87$var$pinErrorMessageDiv = document.getElementById("pinErrorMessage");
const $ea41d65ac2a28d87$var$pinTextBox = document.getElementById("customerPin");
const $ea41d65ac2a28d87$var$spinnerDiv = document.getElementById("spinner");
$ea41d65ac2a28d87$var$initialize();
function $ea41d65ac2a28d87$var$deleteInvalidCharactersFromAccountNumber(accountNumber) {
    const accountNumberFormatRegex = /^[0-9]{10}/;
    if (accountNumberFormatRegex.test(accountNumber) && accountNumber.substring(10, 11).match("/")) {
        accountNumber = accountNumber.substring(0, 11) + accountNumber.substring(11, 16).replace((0, $hJMXW.nonNumericRegex), "");
        accountNumber = accountNumber.substring(0, 12);
    } else accountNumber = accountNumber?.substring(0, 16).replace((0, $hJMXW.nonAlphanumericRegex), "") || "";
    return accountNumber;
}
function $ea41d65ac2a28d87$var$initialize() {
    $ea41d65ac2a28d87$var$accountNumberTextBox.addEventListener("input", ()=>{
        $ea41d65ac2a28d87$var$accountNumberTextBox.value = $ea41d65ac2a28d87$var$deleteInvalidCharactersFromAccountNumber($ea41d65ac2a28d87$var$accountNumberTextBox.value);
    });
    $ea41d65ac2a28d87$var$accountNumberTextBox.addEventListener("paste", (event)=>{
        event.preventDefault();
        const nonAlphaNumericAndBackSlashRegex = /[^0-9a-zA-Z\/]/g;
        const typeText = "text/plain";
        let accountNumberInput = event.clipboardData?.getData(typeText) || "";
        $ea41d65ac2a28d87$var$accountNumberTextBox.value = $ea41d65ac2a28d87$var$deleteInvalidCharactersFromAccountNumber(accountNumberInput.replace(nonAlphaNumericAndBackSlashRegex, ""));
    });
    $ea41d65ac2a28d87$var$accountNumberTextBox.addEventListener("blur", ()=>{
        let isAccountNumberValid = (0, $4rQy7.isValidAccountNumber)($ea41d65ac2a28d87$var$accountNumberTextBox);
        (0, $awDB0.toggleAccountNumberValidationMessage)($ea41d65ac2a28d87$var$accountNumberTextBox, isAccountNumberValid);
    });
    $ea41d65ac2a28d87$var$pinTextBox.addEventListener("input", ()=>{
        $ea41d65ac2a28d87$var$pinTextBox.value = $ea41d65ac2a28d87$var$pinTextBox.value.replace((0, $hJMXW.nonNumericRegex), "");
    });
    $ea41d65ac2a28d87$var$pinTextBox.addEventListener("blur", ()=>{
        let isPinValid = (0, $4rQy7.isValidPin)($ea41d65ac2a28d87$var$pinTextBox);
        (0, $awDB0.togglePinValidationMessage)($ea41d65ac2a28d87$var$pinTextBox, isPinValid);
    });
    document.getElementById("otp-signIn")?.addEventListener("click", async (event)=>{
        event.preventDefault();
        let isAccountNumberValid = (0, $4rQy7.isValidAccountNumber)($ea41d65ac2a28d87$var$accountNumberTextBox);
        let isPinValid = (0, $4rQy7.isValidPin)($ea41d65ac2a28d87$var$pinTextBox);
        (0, $awDB0.toggleAccountNumberValidationMessage)($ea41d65ac2a28d87$var$accountNumberTextBox, isAccountNumberValid);
        (0, $awDB0.togglePinValidationMessage)($ea41d65ac2a28d87$var$pinTextBox, isPinValid);
        if (isAccountNumberValid && isPinValid) {
            (0, $awDB0.showSpinner)($ea41d65ac2a28d87$var$spinnerDiv);
            (0, $8JeXm.getBalanceAsync)("");
        }
    });
    (0, $awDB0.hideErrorDiv)($ea41d65ac2a28d87$var$accountErrorMessageDiv);
    (0, $awDB0.hideErrorDiv)($ea41d65ac2a28d87$var$errorMessageDiv);
    (0, $awDB0.hideErrorDiv)($ea41d65ac2a28d87$var$pinErrorMessageDiv);
    (0, $awDB0.hideSpinner)($ea41d65ac2a28d87$var$spinnerDiv);
    const sessionTimeout = 60000;
    setTimeout((0, $8JeXm.refreshAntiForgeryTokenAsync), sessionTimeout);
}

})();
//# sourceMappingURL=getbalance.js.map
